import { AIInlinePromptPluginKey } from 'common/Prose/Plugins/AIInlinePrompt/AIInlinePrompt'
import { EditorView } from 'prosemirror-view'

export const insertAIPrompt = (view: EditorView, getPos: () => number | undefined) => {
  const {
    state: { tr },
    dispatch,
  } = view

  let position = getPos()
  const firstNode = tr.doc.nodeAt(0)

  // Check if the first node is an empty paragraph
  if (firstNode && firstNode.type.name === 'paragraph' && firstNode.content.size === 0) {
    position = 0
  }

  tr.setMeta(AIInlinePromptPluginKey, { position, active: true })
  dispatch(tr)
}
